module.exports = __webpack_public_path__ + "static/media/technical-support.d8ae61de.svg";